import React from "react";

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{width:"100%", marginTop: '20px'}}
    >
      {value === index && (
        <>
          {children}
        </>
      )}
    </div>
  );
}